<script setup>
import { locationTypes } from '@/constants/locations';

const props = defineProps({
  id: {
    type: [String, Number],
    default: undefined,
  },
  name: {
    type: String,
    default: undefined,
  },
  originalName: {
    type: String,
    default: undefined,
  },
  country: {
    type: Object,
    default: () => ({}),
  },
  stations: {
    type: Array,
    default: () => [],
  },
  locationType: {
    type: String,
    default: locationTypes.CITY,
    validator: (type) => Object.values(locationTypes).includes(type),
  },

  cityId: {
    type: [String, Number],
    default: undefined,
  },

  showStations: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['click']);

const iconName = computed(() =>
  props.locationType === locationTypes.STATION ? 'train-2' : 'location',
);

function emitClick(station) {
  emit('click', station);
}
</script>

<template>
  <div class="lists-city-stations">
    <UiStationButton
      :id="id"
      class="lists-city-stations__city"
      :name="name"
      :city="originalName"
      :country-code="country?.id"
      disable-paddings
      @click="emitClick({ id, name, country: { ...country }, cityId })"
    >
      <template #icon>
        <div class="lists-city-stations__wrapper">
          <CIcon class="lists-city-stations__icon" :name="iconName" />
        </div>
      </template>
    </UiStationButton>

    <div
      v-if="showStations && stations.length"
      class="lists-city-stations__stations"
    >
      <UiStationButton
        v-for="(station, index) in stations"
        :id="station.id"
        :key="index"
        class="lists-city-stations__station"
        :name="station.name"
        :city="originalName"
        :country-code="country?.id"
        icon-name="train-2"
        disable-paddings
        @click="emitClick({ ...station, country: { ...country }, cityId: id })"
      >
        <template #icon>
          <div class="lists-city-stations__wrapper">
            <CIcon class="lists-city-stations__icon" name="train-2" />
          </div>
        </template>
      </UiStationButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.lists-city-stations {
  display: flex;
  flex-direction: column;

  &__icon {
    @include box(em(22));

    flex-shrink: 0;
    color: $color-black;
  }

  &__wrapper {
    @include box(em(28));

    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    margin-right: em(4);
  }

  &__city {
    padding: em(12) 0;
  }

  &__stations {
    display: flex;
    flex-direction: column;
  }

  &__station {
    padding: em(6) 0 em(6) em(12);
  }
}
</style>
